import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BilibiliOutlinedSvg from "@ant-design/icons-svg/es/asn/BilibiliOutlined";
import AntdIcon from '../components/AntdIcon';
var BilibiliOutlined = function BilibiliOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BilibiliOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BilibiliOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BilibiliOutlined';
}
export default RefIcon;